"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CancelledReceiptSerialization = void 0;
class CancelledReceiptSerialization {
    static serialize(entity) {
        const copy = { ...entity };
        return JSON.stringify(copy);
    }
    static deserialize(msg) {
        const entity = JSON.parse(msg);
        const copy = { ...entity };
        return copy;
    }
}
exports.CancelledReceiptSerialization = CancelledReceiptSerialization;
